const maritalStatus = [
  { key: 'Single', value: 'Single' },
  { key: 'Married', value: 'Married' },
  { key: 'Widowed', value: 'Widowed' },
  { key: 'Divorced', value: 'Divorced' },
];
export default maritalStatus;
